import { useCallback } from 'react';
import { sendMessage } from '@wix/ambassador-genie-chat-service-v1-no-entity/http';
import { mapAssistantReference } from '../../../../mapAssistantReference';
export const useSendAssistantMessage = (httpClient, reference, enableLogging) => {
  return useCallback(async (message, conversationId, _agentName) => {
    var _response$data$assist;
    const request = {
      assistantMessages: [{
        content: message
      }],
      conversationId,
      enableLogging,
      assistantConfig: mapAssistantReference(reference)
    };
    const response = await httpClient.request(sendMessage(request));
    const assistantMessage = (_response$data$assist = response.data.assistantMessages) == null ? void 0 : _response$data$assist[0];
    return {
      id: (assistantMessage == null ? void 0 : assistantMessage.id) ?? '',
      createdDate: (assistantMessage == null ? void 0 : assistantMessage.createdDate) ?? new Date(),
      content: (assistantMessage == null ? void 0 : assistantMessage.content) ?? message,
      requestId: response.requestId
    };
  }, [httpClient, enableLogging, reference]);
};
//# sourceMappingURL=useSendAssistantMessage.js.map